import { api_GET, api_POST, api_PUT } from "./_api.js";

const especie_api = {
    getList: (status = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Especie/getlist/${status}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Especie/getitem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (especie) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Especie`, especie)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (especie) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Especie`, especie)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default especie_api;
